import StripeEmbeddedComponentsController from "./stripe_embedded_components_controller"

// Connects to data-controller="stripe-embedded-components-redirection"
export default class extends StripeEmbeddedComponentsController {

  static values = {
    redirectUrl: String
  }

  connect() {
    this.componentConfigurations.push(
      this.#defineExitBehaviour
    )

    super.connect()
  }

  #defineExitBehaviour = (embeddedComponent) => {
    embeddedComponent.setOnExit(this.#onExit);
  }

  #onExit = () => {
    window.location.href = this.redirectUrlValue;
  }
}
